import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

const IndustryCard = ({
  key = null,
  industryData = {},
  onClick = () => {},
}) => {
  return (
    <Box
      key={key}
      onClick={onClick}
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '5px',
        my: '1rem',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
        p: 1,
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '10px',
        },
      }}
    >
      <Grid
        container
        spacing={2}
        alignItems={'center'}
      >
        <Grid
          item
          xs={3}
        >
          <img
            src={industryData.url}
            alt={industryData.title}
            style={{
              width: '100%',
              borderRadius: '10px',
            }}
          />
        </Grid>
        <Grid
          item
          xs={7}
        >
          <Typography
            variant='h6'
            color={'white'}
            fontSize={'1.2rem'}
            fontWeight={'bold'}
          >
            {industryData.title}
          </Typography>
          <Typography
            variant='subtitle1'
            color={'white'}
            fontSize={'1rem'}
          >
            {industryData.description}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default IndustryCard;
